const initialState = {
  featureConfigs: {
    showLicensing: false,
    showDocumentConfig: false,
    showTempPdms: false,
    showBetaTag: false,
    showPDMSSPApp: false,
    showPDMSEApp: false,
    showCloudDevicesApp: false,
    showPlantronicsApp: false,
    showRealAccessApp: false,
    showRealConnectApp: false,
    showOneTouchDialApp: false,
    showAdministrationApp: false,
    showOpsPortalLink: false,
    sessionTimeout: 59 * 60 * 1000
  },
  entitlements: []
};

export const STORE_FEATURE_CONFIGS = "config/STORE_FEATURE_CONFIGS";
export const STORE_ENTITLEMENTS = "config/STORE_ENTITLEMENTS";
export const STORE_SYSTEM_CONFIGS = "config/STORE_SYSTEM_CONFIGS";

export default (state = initialState, action) => {
  switch (action.type) {
    case STORE_SYSTEM_CONFIGS:
      return {
        ...state,
        systemConfigs: action.systemConfigs
      };
    case STORE_FEATURE_CONFIGS:
      return {
        ...state,
        featureConfigs: action.featureConfigs
      };
    case STORE_ENTITLEMENTS:
      return {
        ...state,
        entitlements: action.entitlements
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/config.js